import { injectable } from "inversify";
import IPersistentLog from "./IPersistentLog";
import { PersistentLogLevelEnum } from "./PersistentLogLevelEnum";
import axios, { AxiosStatic } from "axios";
import { inversifyContainer } from 'infrastructure/ioc/ioc.container';
import IRepository from "data/IRepository";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import { Accounts_InsertCustomerLogin, UserInterfaceLog_Log } from "data/endpoints";
import { getDynamicConfig } from "infrastructure/configuration/configurationHelper";
import CustomerSimplifiedDTO from "features/customer/dtos/CustomerSimplifiedDTO";
import { getQueryParams } from "features/shared/helpers/queryParams";

const dynamicConfig = getDynamicConfig();

@injectable()
export default class PersistentLog implements IPersistentLog {
    axios: AxiosStatic;
    baseUrl: string | undefined;
    private readonly _repository: IRepository<object>;

    
    constructor() {
        this.axios = axios;
        this.baseUrl = dynamicConfig.flexiApiUrl || "";
        this._repository = inversifyContainer.get<IRepository<object>>(IocTypes.Repository);
    }
    
    async verbose(message: string, object: Object): Promise<void> { this.persist(PersistentLogLevelEnum.Verbose, message, object) }

    async debug(message: string, object: Object): Promise<void> { this.persist(PersistentLogLevelEnum.Debug, message, object) }

    async information(message: string, object: Object): Promise<void> { this.persist(PersistentLogLevelEnum.Information, message, object) }

    async warning(message: string, object: Object): Promise<void> { this.persist(PersistentLogLevelEnum.Warning, message, object) }

    async error(message: string, object: Object): Promise<void> { this.persist(PersistentLogLevelEnum.Error, message, object) }

    async fatal(message: string, object: Object): Promise<void> { this.persist(PersistentLogLevelEnum.Fatal, message, object) }

    async customerLogin(customer: CustomerSimplifiedDTO, isAdminAccess: boolean): Promise<void> {
        let queryParams: URLSearchParams | undefined;
    
        if (isAdminAccess) {
            queryParams = getQueryParams("ForAdminUse", isAdminAccess.toString());
        }

        await this._repository.post({
            data: customer,
            url: Accounts_InsertCustomerLogin,
            params: queryParams
        })
    }

    private async persist(logLevel: PersistentLogLevelEnum, message: string, object: Object) {
        const params = new URLSearchParams();
        params.set("logEventLevel", logLevel.toString());
        params.set("message", message)

        this._repository.post({
            data: object,
            url: UserInterfaceLog_Log,
            params: params
        })
    }
}